import { FC } from 'react'
import { ToggleHelpDrawer } from './help-drawer/ToggleHelpDrawer'
import { PERMISSION_CONSTANTS } from '../../../app/core/constants/common/permission-constants';
import { HelpDrawer } from './help-drawer/HelpDrawer'
import { AirButton } from './air/AirButton'
import PermissionWrapper from '@/core/wrappers/permission-wrapper';

const RightToolbar: FC = () => {
  return (
    <>
      <div className='engage-toolbar d-flex position-fixed px-5 fw-bold zindex-2 top-50 end-0 mt-20 gap-2'>
        {/* <ToggleHelpDrawer /> */}
        <PermissionWrapper permission={PERMISSION_CONSTANTS.AIR}>
          <AirButton />
        </PermissionWrapper>
      </div>

      <HelpDrawer />
    </>
  )
}

export { RightToolbar }
